

/**
 * @param {string} url - file url
 * @returns {boolean} - true if file is external
 */
export const isExternalFile = (url) => {
  if (!url) return false
  
  const externalDomains = [
    's3.'
  ]
  
  return externalDomains.some(domain => url.includes(domain))
}

/**
 * @param {string|object} link 
 * @returns {string} - file extension
 */
export const getFileExtension = (link) => {
  if (!link) return ''
  
  const url = typeof link === 'string' ? link : link.file
  if (!url) return ''
  
  const res = url.match(/\w+\.[A-Za-z]{3,4}(?=\?|$)/g)
  return res ? res[0].split('.')[1] : ''
}

/**
 * @param {string} url - file url
 * @param {string} fileName - file name for fallback
 */
export const safeOpenFile = (url, fileName = '') => {
  if (!url) return
  if (isExternalFile(url)) {
    console.log('Open external file directly:', url)
    window.open(url, '_blank', 'width=1200,height=800,scrollbars=yes,resizable=yes')
  } else {
    window.open(url, '_blank', 'width=1200,height=800,scrollbars=yes,resizable=yes')
  }
}
